import './styles.scss'

import React from 'react'
import { useValues } from 'kea'
import PropTypes from 'prop-types'

import Capitalize from 'lib/utils/capitalize'
import I18n from 'lib/i18n'

import priceIcon from '../_assets/price-icon.svg'
import ArrowIcon from '../_assets/arrow-icon.svg'

import courseLogic from '~/scenes/course/show/logic'

const Price = ({ onClick }) => {
  const {
    course: { price, currencySymbol }
  } = useValues(courseLogic)

  return (
    <div className='price-container' onClick={onClick}>
      <div className='price-icon-container'>
        <img className='price-icon' alt='course price icon' src={priceIcon} width={22} height={17} />
      </div>
      <div className='price-text-container'>
        <span className='first-part'>{`${Capitalize(I18n.t('courses.show.from'))} `}</span>
        <span>{`${price} ${currencySymbol}`}</span>
        <span className='per-hour-text'>{` ${I18n.t('courses.show.per_hour_custom')}`}</span>
      </div>
      <div className='arrow-icon-container'>
        <img className='arrow-icon' alt='arrow icon' src={`${ArrowIcon}`} width={20} height={20} />
      </div>
    </div>
  )
}

Price.propTypes = {
  onClick: PropTypes.func
}

export default Price
